<template>
    <v-list dense v-bind="$attrs">
        <v-subheader v-if="subtitle">
            <span class="text-caption">{{ subtitle }}</span>
        </v-subheader>
        <v-list-item-group 
                v-model="selected"
                :color="color">
                <v-list-item
                    v-for="(item, i) in localItems"
                    :key="i"
                    @click="emit('on-select', item)"
                >
                    <v-list-item-content>
                        <v-list-item-title>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">{{ item[column] }}</span>
                                </template>
                                <span>{{ item[column] }}</span>
                            </v-tooltip>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
        </v-list-item-group>
    </v-list>
</template>

<script setup>

import { ref, defineProps, defineEmits, watch } from 'vue';

const emit = defineEmits('on-select', 'on-open')

const props = defineProps({
    color: { type: String, default: 'primary' },
    items: { type: Array, default: [] },
    column: { type: String, default: 'name' },
    subtitle: { type: String, required: false }
})

const selected = ref(null)
const localItems = ref(props.items)

watch(() => props.items, (val) => {
    localItems.value = val
    selected.value = null
})

</script>